<template>
<div class="container-fluid landing-page">
	<div v-if="isValidating">
		<div class="row">
			<div class="col-3 border">
				<SfeSkeleton :height="'100px'" class="mt-4"/>
				<div  v-for="index in 10" :key="index" class="mt-4">
					<SfeSkeleton :height="'25px'" />
				</div>
			</div>
			<div class="col-9">
				<div  v-for="index in 3" :key="index" class="mt-4">
					<SfeSkeleton :height="'200px'" class="mb-2"/>
				</div>
			</div>
		</div>
	</div>
	<div v-else>
		<div class="d-flex justify-content-center align-items-center" v-if="isSocialMediaAuth" style="height: 90vh">
			<LayoutLoader />
		</div>
		<div v-show="!isSocialMediaAuth">
			<div class="row landing-page__inner-container">
					<div class="text-center left-section col-xs-12 col-md-6">
						<div class="left-section__right-svg-icon">
							<svg width="174" height="71" viewBox="0 0 174 71" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path opacity="0.3" d="M323.138 -215.225C369.866 -173.687 373.443 -81.3977 340.639 -19.1922C307.868 42.8908 238.76 74.9675 165.498 69.6753C92.2363 64.3831 14.6971 21.6884 2.40507 -35.8205C-9.85305 -93.4519 43.1698 -166.02 114.722 -206.917C186.24 -247.692 276.365 -256.84 323.138 -215.225Z" fill="#9DBCDC"/>
							</svg>
						</div>
	
						<img
							:src="`${bannerLink || previewBannerImg}`"
							class="seamless-job-desktop-img"
							alt="Seamless jobs desktop"/>
						<h1 class="text-light-blue-1 fw-500 landing-page__primary-heading">Welcome to <span v-html="client_name"></span>'s job portal</h1>
						<p class="text-light-grey-1 landing-page__secondary-heading text-center mt-2">{{ landingPageMessage }}</p>
	
						<div class="left-section__left-svg-icon">
							<svg width="129" height="49" viewBox="0 0 129 49" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path opacity="0.3" d="M89.1378 27.7753C135.866 69.3126 139.443 161.602 106.639 223.808C73.8679 285.891 4.76033 317.968 -68.5017 312.675C-141.764 307.383 -219.303 264.688 -231.595 207.179C-243.853 149.548 -190.83 76.9798 -119.278 36.0827C-47.7603 -4.69196 42.3651 -13.84 89.1378 27.7753Z" fill="#9DBCDC"/>
							</svg>
						</div>
						<p :class="{'fs-13 text-center': true, 'footer-bottom': activeComponentIsLoginForm, 'footer-normal': activeComponent !== 'LoginWrapper'}"> {{ getYear }} SHR All rights reserved</p>
					</div>
	
					<div class="right-section  col-md-6">
						<!-- Admin portal login button -->
						 <div v-if="activeComponent !== 'LoginWrapper'" class="mt-5">
							<SfeButton variant="bare" @click.prevent="activeComponent = 'LoginWrapper'" class="btn text-primary  d-flex align-items-center">
								<span class="material-icons fs-20">
									arrow_back
								</span>
								<span class="fw-400 fs-16 ml-1">Back</span>
							</SfeButton>
						 </div>
						<div class="d-flex flex-column justify-content-center py-3 mt-5">
							<!-- This logo will show from mid resolution screen (>= 768px) -->
							<div class="right-section__inner-container">
								<div
								  :class="{
									'logo-container justify-content-center': true,
									'justify-content-start': logoPlacement === 'left' || !logoPlacement && company.logo_placement === 'left',
									'justify-content-center': logoPlacement === 'center' || !logoPlacement && company.logo_placement === 'center',
									'right-section__seamless-jobs-logo1 my-2': true,
									'mt-5': true,
									'd-none': (!isHomePage && $route.name !== 'Admin.Settings.Company')
	
								  }">
								  <img
									  :src="`${logoLink || previewLogo}`"
									alt="Logo"
								  />
								</div>
								<transition name="fade" mode="out-in" appear>
									<component
										:is="activeComponent"
										@check:user-session="checkActiveHRMSSession"
										@registration:successful="handleSuccessfulRegistration"
										@login:successful="handleSuccessfulLogin"
										@failed:social-media-auth="isSocialMediaAuth = false"
										@start:social-media-auth="handleStartSocialMediaAuth"
										@show:login-form="setActiveComponent('LoginForm')"
										@show:registration-form="setActiveComponent('RegistrationForm')"
										@show:send-reset-link-to-email-form="setActiveComponent('SendResetPasswordLinkToEmailForm')"
										@reset-link-to-email:successful="setActiveComponent('ResetPasswordForm')"
										:company="company"
										:logo-placement="logoPlacement"
										:isLandingPage="true"
										@log-in-as-another-user="currentUserHasSession = false"
										@close-session-modal="setActiveComponent('LoginWrapper')"
								:userHasSession="currentUserHasSession"
								:sessionUserDetails="currentSessionUSerDetails"
									/>
								</transition>
								<!-- This only shows when the login page is on -->
								<div class="text-center mt-5 border border-primary login-form__skip-section--md" v-show="activeComponentIsLoginForm">
									 <div class="login-form__skip-section__flex-container">
										 <p class="fw-500 text-primary mb-1 fs-16 login-form__skip-section__flex-container--primary-text">
											 Explore latest job postings
										 </p>
										 <p class="text-primary fs-13 mb-0">Find jobs you might be interested in</p>
									 </div>
									 <a href="h/advanced#/jobs" class="text-primary fw-500 fs-15"  id="view_jobs">View Jobs</a>
								</div>
							</div>
						</div>
					</div>
	
			</div>
			<!-- View jobs section for mobile login form begins -->
	
				<!-- View jobs section for mobile login form ends -->
	
	
				<!-- Admin modal starts here -->
	
				<div>
					<b-modal
						v-model="showAdminLoginModal"
						id="admin-modal"
						 @hide="resetAdminModal"
						 centered :body-class="['bg-white', 'rounded', 'border']" hide-header hide-footer size="md">
						<div class="d-flex justify-content-end align-items-center">
							<span class="material-icons text-primary cursor-pointer" @click.prevent="$bvModal.hide('admin-modal')">close</span>
						</div>
						<transition name="fade" mode="out-in">
							<component
								:is="activeAdminComponent"
								@show:admin-login-form="setActiveAdminComponent('adminLogin')"
								@show:login-form="setActiveComponent('adminLogin')"
								@show:admin-send-reset-password-link="setActiveAdminComponent('SendResetPasswordLinkToEmailForm')"
								@show:admin-reset-password="setActiveAdminComponent('adminResetPasswordLinkToEmail')"
								@reset-link-to-email:successful="handleAdminResetLinkToEmailSuccess"
								@reset-password:successful="setActiveAdminComponent('PasswordChangeSuccessPage')"
								:company="company"
								:isRenderedOnModal="true"
								@show-login-form="showAdminLoginForm"
								:passwordResetSuccess="passwordResetSuccess"
								:emailResetLinkSuccess="emailResetLinkSuccess"
								:isLandingPage="true"
								:isAdminPage="true"
								  :logoLink="logoLink"
							/>
						</transition>
					</b-modal>
				</div>
	
				<!-- Admin modal ends here -->
		</div>
	</div>
	</div>
</template>

<script>
// import LoginForm from '../../components/auth/candidate/LoginForm'
// LaravelEncrypt removed - using AsymmetricEncryptionService instead
import LoginForm from '../../components/auth/LoginForm'
import RegistrationForm from '../../components/auth/RegistrationForm'
import ResetPasswordForm from '../../components/auth/candidate/ResetPassword'
import SendResetPasswordLinkToEmailForm from '../../components/auth/SendResetPasswordLinkToEmail'
import AdminLogin from '../../components/auth/admin/Login'
import SuccessPage from '../../components/auth/SuccessPage'
import LayoutLoader from "../admin/jobs/job-management/applicant-tracking-system/includes/loaders/job-preferences/JobPreferences.vue"
import LoginWrapper from '../../components/auth/LoginWrapper.vue'
import AdminModel from '../../models/AdminModel'

export default {
	name: 'landingPage',
	mixins: [AdminModel],
	components: {
		LoginForm,
		RegistrationForm,
		ResetPasswordForm,
		SendResetPasswordLinkToEmailForm,
		AdminLogin,
		SuccessPage,
		LayoutLoader,
		LoginWrapper
	},
	props: {
		logoLink: {
			type: String,
			default: ''
		},
		bannerLink: {
			type: String,
			default: ''
		},
		showAdminLogin: {
			type: String,
			default: 'no'
		},
		landingPageMessage: {
			type: String,
			default: 'We are an equal opportunity employer; all stages of the employment process will be based on merit, competence, performance and business needs.'
		},
		previewBannerImg: {
			type: String,
			default: ''
		},
		previewLogo: {
			type: String,
			default: ''
		},
		logoPlacement: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			currentUrl: '',
			magicLinkToken: '',
			userType: '',
			isValidating: false,
			currentUserHasSession: false,
			currentSessionUSerDetails: {},
			showAdminLoginModal: false,
			activeComponent: 'LoginWrapper',
			activeAdminComponent: 'AdminLogin',
			company: {
				logo_placement: ''
			},
			companyKeyInSessionStorage: false,
			isSocialMediaAuth: false,
			emailResetLinkSuccess: false,
			passwordResetSuccess: false,
			banner_image: '/homepage/images/seamless-hiring-desktop.png',
			logo_image: '',
      client_name: sessionStorage.getItem('client_name') || 'SeamlessHiring',
      timerId: ''
		}
	},
	computed: {
		redirectPath() {
			if(this.currentUrl) {
				return `${location.origin}/candidate/advanced${this.currentUrl}`
			}else {
				return '/candidate/advanced#/applications?login=true'
			}
		},
		activeComponentIsLoginForm() {
			return this.activeComponent === 'LoginWrapper'
		},
		getYear(){
			const date = new Date()
			return date.getFullYear()
		},
		isHomePage() {
			const currentPath = window.location.pathname
			if (currentPath === "/") {
				return true
			}

			return false
		}

	},
  mounted() {
    if (window.location.pathname !== '/' || window.location.search || window.location.hash) {
        this.currentUrl = window.location.hash;
    }

	const url = new URL(window.location.href);
	const params = new URLSearchParams(url.search);

	this.magicLinkToken = params?.get('login_token') || null;
	this.userType = params?.get('user_type') || null;

	if (params?.get('signup') === 'true') {
		this.activeComponent = 'RegistrationForm'
	}

	if(this.magicLinkToken) {
		this.validateMagicTokenLogIn();
	}
	this.trackEvent('rms_login_start_sh', {})
	// the sessionStorage is set by php getting data by the backend
	// this sessionStorage may not exist in the browser by the time of mounting
    let company = this.fetchCompanyObjectInSessionStorage()

	if (!company) {
		// every second, search for company key in the sessionStorage
		this.timerId = setInterval(this.fetchCompanyObjectInSessionStorage, 1000)
	} else {
		this.company = JSON.parse(company)
		this.setLogoAndBannerImage()
	}

  },
  methods: {
		validateMagicTokenLogIn() {
			this.isValidating = true;
			const payload = {
				token: this.magicLinkToken,
				user_type: this.userType
			}
			this.AdminModel.validateMagicTokenLogIn(payload)
			.then((r) => {
				this.$sfeToast.toast('success', 'Success', r.message);
				location.href = this.userType == 'admin' ? '/admin/advanced#/dashboard?login=true' : '/candidate/advanced#/applications?login=true';
			})
			.catch((e) => {
				this.$sfeToast.toast('error', 'Error', e.message)
				this.isValidating = false;
			})
		},
		checkActiveHRMSSession() {
			const getSessionData = this.$localEncrypt.getData('__k2pzl');
			if(getSessionData.is_stand_alone == 0) {
				window.open(`${getSessionData.hrms_url}/api/internal-recruitment/get-active-user-session?call_back=${window.location.origin}`, 'authWindow', 'width=600,height=400');
				window.addEventListener('message', (event) => {
					if (event.origin !== getSessionData.hrms_url || !event?.data?.user) {
						return; // Only accept messages from HRMS domain
					}
					this.currentSessionUSerDetails = event?.data;
					this.currentUserHasSession = true;
				});
			}
			// this.showAdminLoginModal = true;
			this.setActiveComponent('adminLogin')
		},
		fetchCompanyObjectInSessionStorage() {
			const company = sessionStorage.getItem('company')

			if (company) {
				this.companyKeyInSessionStorage = true
				return company
			}
			return null

		},
		setLogoAndBannerImage() {
			if	(this.company?.logo_link) {
				this.logo_image = this.company.logo_link
			}
			if (!this.company?.use_default_banner && this.company?.banner_image_link) {
				this.banner_image = this.company?.banner_image_link
			}
		},
  		getQueryParams(url) {
  		    const paramArr = url.slice(url.indexOf('?') + 1).split('&');
  		    const params = {};
  		    paramArr.map(param => {
  		        const [key, val] = param.split('=');
  		        params[key] = decodeURIComponent(val);
  		    })
  		    return params;
  		},
		handleSuccessfulRegistration() {
			window.location.href = '/candidate/advanced#/applications'
		},
		handleStartSocialMediaAuth() {
			this.isSocialMediaAuth = true
		},
		handleSuccessfulLogin() {
			const url = this.getQueryParams(document.URL)
			window.location.href = url.redirect ? url.redirect : this.redirectPath;
		},
		setActiveComponent(newComponent) {
			this.activeComponent = newComponent
		},
		setActiveAdminComponent(newComponent) {
			this.activeAdminComponent = newComponent
		},
		showAdminLoginForm() {
			this.activeAdminComponent = 'AdminLogin'
		},
		resetAdminModal() {
			this.activeAdminComponent = 'AdminLogin'
		},
		handleAdminResetLinkToEmailSuccess() {
			this.passwordResetSuccess = false
			this.emailResetLinkSuccess = π
			this.$nextTick(() => {
				this.setActiveAdminComponent('SuccessPage')
			})
		}
	},
	watch: {
		companyKeyInSessionStorage(newValue) {
			// if company key is found in sessionStorage ...
			if (newValue) {
				const company = this.fetchCompanyObjectInSessionStorage()

				this.company = JSON.parse(company)
				this.setLogoAndBannerImage()
				// clear the interval once the company key is found in sessionStorage
				clearInterval(this.timerId)
			}

		}
	}
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 320px) {
		.landing-page {
			position: relative;
			&__inner-container {
				display: flex;
				flex-direction: column;
			}
			&__primary-heading {
				font-size: 20px;
				margin-top: 24px
			}
			&__secondary-heading {
				font-size: 14px;
			}
		}
    .seamless-job-desktop-img {
		display: none
	}
		.left-section {
			background-color: #D8E4F1;
			position: relative;
			padding: 40px 20px;
			&__right-svg-icon {
				position: absolute;
				top: 0;
				right: 0
			}
			&__left-svg-icon {
				position: absolute;
				left: 0;
				bottom: 0;
			}
		}
		.right-section {
			padding: 12px;
			min-height: 100vh;
			&__seamless-jobs-logo  {
				display: none;
			}
		}
		.login-form__skip-section--md {
			display: none;
		}
}

@media screen and (min-width: 768px) {
	.landing-page {
  position: relative;
  min-height: 100vh;
		&__inner-container {
			flex-direction: row;
		}
		&__primary-heading {
			font-size: 20px;
			margin-bottom: 15px;
			margin-top: 20px;
		}
		&__secondary-heading {
			font-size: 15px;
		}
	}
	.seamless-job-desktop-img {
		display: inline;
		width: 65%;
		height: auto;
		margin-top: -4px;
	}
	.left-section {
		min-height: 100vh;
		background-color: #F4F7FB;
		position: relative;
		padding: 8% 5% 0;
		&__right-svg-icon {
			display: none
		}
		&__left-svg-icon {
			display: none;
		}
	}
	.right-section {
		min-height: 100vh;
		background-color: #ffffff;
		padding: 0 3%;
		&__inner-container {
			width: 100%;
            max-width: 90%;
            margin: 0 auto;
            height: fit-content;
		}
		&__seamless-jobs-logo  {
			object-fit: cover;
      		min-width: 132px;
			max-height: 132px;
			display: inline-block
		}
	}

	.login-form__skip-section--md {
		position: absolute;
		bottom: 2vh;
		left: 96px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: calc(100% - 11vw);
		background: #F4F7FB;
		border: 1px solid #296DB3 !important;
		border-radius: 8px;
		padding: 12px 24px;
		box-sizing: border-box;
	}
	.login-form__skip-section__flex-container {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		&--primary-text {
			line-height: 0.9
		}
	}
}


.bg-dark-grey-1 {
    background-color: #454545
}

.bg-blue-1 {
    background-color: #296DB3;
}

.bg-light-blue-1 {
    background-color: #DCDFF1
}

.border-light-blue-1 {
   border-color: #D8E4F1
}
.border-light-grey-2 {
   border-color: #dddddd
}

.bg-light-blue-1 {
   background-color: #D8E4F1
}

.border-grey-1 {
    border-color: #dfdfdf
}

.heading-blue {
    color: #1E5083
}
.footer-bottom{
	margin-top: 5rem;
	color: #AAAAAA;
	position: absolute;
	bottom: 2vh;
	left: 0;
	right: 0;
}
.footer-normal{
	margin-top: 5rem;
	color: #AAAAAA;
}
</style>
